import { useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import IndividualInfoCard from "../components/viewIndividual/IndividualInfoCard";
import ModalNewDataIndividual from "../components/viewIndividual/ModalNewDataIndividual";
import { useGetIndividualById } from "@services/individuals/getById";
import { toast } from "react-toastify";
import IndividualsEventTable from "../components/viewIndividual/IndividualsEventTable";
import GpsEvents from "../components/viewIndividual/gpsEvents/GpsEvents";
import ModalEditIndividual from "../components/ModalEditIndividual";

function ViewIndividual() {
  const { id } = useParams<{ id: string }>();

  const {
    data: individual,
    isLoading,
    error,
  } = useGetIndividualById(id ?? null);

  if (error) {
    toast.error("Erro ao carregar os dados do indivíduo.");
    return null;
  }

  if (!isLoading && !individual) {
    toast.warning("Indivíduo não encontrado.");
    return null;
  }

  if (!id) {
    toast.error("ID do indivíduo não fornecido.");
    return null;
  }

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <CircularProgress size={60} className="text-primary" />
        </div>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-5 lg:grid-rows-4 gap-4">
          <div className="lg:row-span-4 lg:col-span-2">
            <IndividualInfoCard individual={individual} />
          </div>

          <div className="lg:row-span-4 lg:col-span-3 flex flex-col gap-4">
            <GpsEvents
              hasGPS={individual?.hasGPS ?? false}
              lastLocationLatitude={individual?.lastLocationLatitude}
              lastLocationLongitude={individual?.lastLocationLongitude}
            />
            <IndividualsEventTable individualId={id} />
          </div>
        </div>
      )}
      <ModalNewDataIndividual individualId={id} />
      <ModalEditIndividual />
    </>
  );
}

export default ViewIndividual;
